import { buildI18nInjectionToken } from '@pct-ng/transloco';

const I18nScope = 'ng/i18n';
export const I18nProviderInjectionToken = buildI18nInjectionToken(I18nScope);
